import { render, staticRenderFns } from "./IconCopyText.vue?vue&type=template&id=c06964a0&scoped=true&"
import script from "./IconCopyText.vue?vue&type=script&lang=js&"
export * from "./IconCopyText.vue?vue&type=script&lang=js&"
import style0 from "./IconCopyText.vue?vue&type=style&index=0&id=c06964a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06964a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
